export default `float s=2.;
    float e = 0;
    float l=dot(p,p);
    p=abs(abs(p)-.4)-.2;
    p.x<p.y?p=p.yxz:p;
    p.y<p.z?p=p.xzy:p;
    for(int i=0;i++<8;){
      s*=e=2./min(dot(p,p),1.3);
      p=abs(p)*e-vec2(l,16.).xxy;
    }
    return length(p)/s;
  }`